<div class="np-ai" [class.sidebar-open]="sidebarOpen" (click)="closeMenus()">

  <!-- ===== 왼쪽: 채팅방 목록 ===== -->
  <aside class="np-ai-side">
    <div class="np-ai-side-top">
      <button type="button" class="np-ai-icon-btn" title="사이드바 닫기" (click)="toggleSidebar()">
        <i class="bi bi-layout-sidebar"></i>
      </button>
      <button type="button" class="np-ai-new" (click)="newChat()" [disabled]="sending">
        <i class="bi bi-pencil-square"></i><span>새 채팅</span>
      </button>
      <button type="button" class="np-ai-icon-btn" [class.active]="settingOpen" title="설정" (click)="toggleSetting($event)">
        <i class="bi bi-gear"></i>
      </button>
    </div>

    <div class="np-ai-search">
      <i class="bi bi-search"></i>
      <input type="text" placeholder="채팅 검색" [(ngModel)]="roomFilter" (ngModelChange)="groupRooms()">
    </div>

    <nav class="np-ai-rooms">
      <div *ngIf="roomsLoading && rooms.length === 0" class="np-ai-side-empty">불러오는 중…</div>
      <div *ngIf="!roomsLoading && roomGroups.length === 0" class="np-ai-side-empty">
        {{ roomFilter ? '찾는 채팅이 없습니다' : '아직 채팅이 없습니다' }}
      </div>

      <section *ngFor="let group of roomGroups">
        <h6 class="np-ai-group-label">{{ group.label }}</h6>
        <div *ngFor="let room of group.rooms; trackBy: trackById" class="np-ai-room"
          [class.active]="room.id === currentRoomId" (click)="openRoom(room)">
          <ng-container *ngIf="renamingRoomId !== room.id; else renameTpl">
            <span class="np-ai-room-title" [title]="room.title">{{ room.title }}</span>
            <span class="np-ai-room-actions">
              <button type="button" title="이름 바꾸기" (click)="startRename(room, $event)"><i class="bi bi-pencil"></i></button>
              <button type="button" title="삭제" (click)="deleteRoom(room, $event)"><i class="bi bi-trash3"></i></button>
            </span>
          </ng-container>
          <ng-template #renameTpl>
            <input class="np-ai-rename-input" [(ngModel)]="renameText" (click)="$event.stopPropagation()"
              (keydown.enter)="commitRename(room)" (keydown.escape)="cancelRename()" (blur)="commitRename(room)">
          </ng-template>
        </div>
      </section>
    </nav>
  </aside>

  <div class="np-ai-backdrop" (click)="toggleSidebar()"></div>

  <!-- ===== 오른쪽: 대화 ===== -->
  <main class="np-ai-main" (dragenter)="onDragEnter($event)" (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">

    <!-- 끌어 놓는 중 -->
    <div *ngIf="dragActive" class="np-ai-drop" [class.disabled]="!options.attachmentEnabled">
      <div class="np-ai-drop-box">
        <i class="bi" [class.bi-cloud-arrow-up]="options.attachmentEnabled" [class.bi-slash-circle]="!options.attachmentEnabled"></i>
        <ng-container *ngIf="options.attachmentEnabled; else dropOff">
          <strong>여기에 파일을 놓으세요</strong>
          <span>이미지·PDF·글 · {{ options.attachmentMaxFiles }}개까지 · 개당 {{ formatBytes(options.attachmentMaxFileBytes) }}</span>
          <span>파일은 저장하지 않고 이번 질문에만 AI로 보냅니다</span>
        </ng-container>
        <ng-template #dropOff><strong>파일을 첨부할 수 없습니다</strong></ng-template>
      </div>
    </div>

    <header class="np-ai-head">
      <button *ngIf="!sidebarOpen" type="button" class="np-ai-icon-btn" title="사이드바 열기" (click)="toggleSidebar()">
        <i class="bi bi-layout-sidebar"></i>
      </button>
      <button *ngIf="!sidebarOpen" type="button" class="np-ai-icon-btn" title="새 채팅" (click)="newChat()" [disabled]="sending">
        <i class="bi bi-pencil-square"></i>
      </button>
      <button *ngIf="!sidebarOpen" type="button" class="np-ai-icon-btn" [class.active]="settingOpen" title="설정" (click)="toggleSetting($event)">
        <i class="bi bi-gear"></i>
      </button>
      <!-- 모델 선택 -->
      <div class="np-ai-model">
        <button type="button" class="np-ai-model-btn" [class.fixed]="!options.modelSelectable"
          (click)="toggleModelMenu($event)" [title]="options.modelSelectable ? '모델 고르기' : '이 채팅은 기본 모델을 씁니다'">
          <span>{{ selectedModelInfo?.name || selectedModel || '기본 모델' }}</span>
          <i *ngIf="options.modelSelectable" class="bi bi-chevron-down"></i>
        </button>
        <div *ngIf="modelMenuOpen" class="np-ai-model-menu" (click)="$event.stopPropagation()">
          <div class="np-ai-model-menu-label">모델</div>
          <button type="button" *ngFor="let model of options.models" class="np-ai-model-item"
            [class.active]="model.id === selectedModel" (click)="selectModel(model)">
            <span class="np-ai-model-item-text">
              <span class="np-ai-model-item-name">
                {{ model.name }}
                <span *ngIf="model.id === options.defaultModel" class="np-ai-model-badge">기본</span>
                <span *ngIf="model.provider === 'ollama'" class="np-ai-model-badge ollama">사내</span>
              </span>
              <span *ngIf="model.description" class="np-ai-model-item-desc">{{ model.description }}</span>
            </span>
            <i *ngIf="model.id === selectedModel" class="bi bi-check2"></i>
          </button>
        </div>
      </div>
      <div class="np-ai-head-title">{{ currentTitle }}</div>
      <button *ngIf="inModal" type="button" class="np-ai-icon-btn" title="닫기" (click)="closeModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </header>

    <div class="np-ai-scroll" #scroller>
      <!-- 빈 화면 -->
      <div *ngIf="!currentRoomId && messages.length === 0" class="np-ai-welcome">
        <div class="np-ai-logo"><i class="bi bi-stars"></i></div>
        <h2>무엇을 도와드릴까요?</h2>
        <div class="np-ai-suggestions">
          <button type="button" *ngFor="let s of suggestions" (click)="useSuggestion(s)" [disabled]="sending">
            {{ s }}
          </button>
        </div>
      </div>

      <div *ngIf="roomLoading" class="np-ai-thread">
        <div class="np-ai-skeleton" *ngFor="let w of [70, 90, 55]" [style.width.%]="w"></div>
      </div>

      <div class="np-ai-thread" *ngIf="!roomLoading">
        <ng-container *ngFor="let m of messages; trackBy: trackByKey">
          <!-- 질문 -->
          <div *ngIf="m.role === 'USER'" class="np-ai-msg user" [class.failed]="m.failed">
            <div *ngIf="m.fileNames?.length" class="np-ai-sent-files">
              <span *ngFor="let name of m.fileNames" class="np-ai-sent-file" [title]="name">
                <i class="bi bi-paperclip"></i>{{ name }}
              </span>
            </div>
            <div class="np-ai-bubble">{{ m.content }}</div>
            <div *ngIf="m.failed" class="np-ai-failed">
              <i class="bi bi-exclamation-circle"></i> {{ errorText }}
              <button type="button" (click)="retry(m)"><i class="bi bi-arrow-clockwise"></i> 다시 보내기</button>
            </div>
          </div>

          <!-- 답 -->
          <div *ngIf="m.role === 'ASSISTANT'" class="np-ai-msg assistant">
            <div class="np-ai-avatar"><i class="bi bi-stars"></i></div>
            <div class="np-ai-answer">
              <div class="np-ai-md" [innerHTML]="m.html" (click)="onAnswerClick($event)"></div>
              <div class="np-ai-meta">
                <button type="button" class="np-ai-icon-btn sm" [title]="copiedKey === m.key ? '복사됨' : '복사'" (click)="copy(m)">
                  <i class="bi" [class.bi-check2]="copiedKey === m.key" [class.bi-copy]="copiedKey !== m.key"></i>
                </button>
                <span *ngIf="m.model" class="np-ai-meta-text">
                  {{ modelName(m.model) }}<ng-container *ngIf="m.inputTokens != null"> · 토큰 {{ m.inputTokens | number }} / {{ m.outputTokens | number }}</ng-container>
                </span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- 답 기다리는 중 (파일을 보내는 중이면 진행률) -->
        <div *ngIf="sending" class="np-ai-msg assistant">
          <div class="np-ai-avatar thinking"><i class="bi bi-stars"></i></div>
          <div *ngIf="progress?.phase === 'uploading'; else typing" class="np-ai-upload">
            <div class="np-ai-upload-text">
              파일 보내는 중 <strong>{{ progress?.percent ?? 0 }}%</strong>
              <span *ngIf="progress?.total">· {{ formatBytes(progress!.loaded) }} / {{ formatBytes(progress!.total) }}</span>
            </div>
            <div class="np-ai-upload-bar"><div [style.width.%]="progress?.percent ?? 0"></div></div>
          </div>
          <ng-template #typing>
            <div class="np-ai-typing"><span></span><span></span><span></span></div>
          </ng-template>
          <button *ngIf="canCancel" type="button" class="np-ai-cancel" (click)="cancelSend()">
            <i class="bi bi-x-lg"></i> 취소
          </button>
        </div>
      </div>
    </div>

    <!-- 입력 -->
    <footer class="np-ai-composer-wrap">
      <div *ngIf="fileRejects.length" class="np-ai-rejects">
        <div *ngFor="let r of fileRejects"><i class="bi bi-exclamation-triangle"></i> {{ r }}</div>
      </div>
      <form class="np-ai-composer" [class.has-files]="pendingFiles.length" (submit)="$event.preventDefault(); send()">
        <div *ngIf="pendingFiles.length" class="np-ai-files">
          <div *ngFor="let f of pendingFiles; trackBy: trackByKey" class="np-ai-file" [title]="f.file.name">
            <img *ngIf="f.previewUrl; else fileIcon" [src]="f.previewUrl" alt="">
            <ng-template #fileIcon>
              <span class="np-ai-file-icon" [ngClass]="f.kind">
                <i class="bi" [class.bi-file-earmark-pdf]="f.kind === 'pdf'" [class.bi-file-earmark-text]="f.kind === 'text'"
                  [class.bi-file-earmark-image]="f.kind === 'image'"></i>
              </span>
            </ng-template>
            <span class="np-ai-file-text">
              <span class="np-ai-file-name">{{ f.file.name }}</span>
              <span class="np-ai-file-size">{{ formatBytes(f.file.size) }}</span>
            </span>
            <button type="button" class="np-ai-file-remove" title="빼기" (click)="removeFile(f)" [disabled]="sending">
              <i class="bi bi-x"></i>
            </button>
          </div>
        </div>
        <div class="np-ai-composer-row">
        <textarea #input rows="1" [(ngModel)]="draft" name="draft" placeholder="NOVA AI에게 물어보세요"
          (input)="autoGrow()" (keydown)="onKeydown($event)"
          (compositionstart)="onCompositionStart()" (compositionend)="onCompositionEnd()"></textarea>
        <button type="submit" class="np-ai-send" [disabled]="!draft.trim() || sending" title="보내기 (Enter)">
          <i class="bi" [class.bi-arrow-up]="!sending" [class.bi-hourglass-split]="sending"></i>
        </button>
        </div>
      </form>
      <div class="np-ai-notice">
        업무용입니다. 대화는 저장되고 외부 AI(Google)로 전송됩니다. 개인정보·고객정보는 넣지 마세요. AI 답은 틀릴 수 있습니다.
        <ng-container *ngIf="attachmentHint"><br>{{ attachmentHint }}</ng-container>
      </div>
    </footer>
  </main>

  <!-- 개인 AI 설정 (오른쪽 패널) -->
  <div *ngIf="settingOpen" class="np-ai-setting-backdrop" (click)="toggleSetting($event)"></div>
  <aside *ngIf="settingOpen" class="np-ai-setting" (click)="$event.stopPropagation()">
    <header>
      <span>설정</span>
      <button type="button" class="np-ai-icon-btn" title="닫기" (click)="toggleSetting()"><i class="bi bi-x-lg"></i></button>
    </header>
    <div class="np-ai-setting-body">
      <newpla-ai-user-setting />
    </div>
  </aside>
</div>
